import React, { useState } from 'react';
import {
    Box,
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import {
    Button,
    Counter,
    Icon,
    IconsNames,
} from 'shared';
import { useNavigate } from 'react-router-dom';
// eslint-disable-next-line no-restricted-imports
import { Modal } from 'shared/ui/Modal';
import { LuTrash } from 'react-icons/lu';
import { useCart } from '../../lib';

type CartAddButtonWithCounterProps = {
    type: 'delivery' | 'culinary-studio' | 'outdoor-bars' | 'sweet-shop' | 'cake-to-order',
    uid: string,
    portionIndex?: number,
    withClear?: boolean
} & GridProps & React.RefAttributes<HTMLDivElement>

export const CartAddButtonWithCounter
: React.FC<CartAddButtonWithCounterProps> = ({
    type,
    uid,
    portionIndex,
    withClear,
    ...props
}) => {
    const navigate = useNavigate();
    const { setItem, getItemCount } = useCart();

    const count = getItemCount(type, uid, portionIndex);

    const [open, setOpen] = useState(false);

    const handleClose = () => setOpen(false);

    const handleOpen = () => setOpen(true);

    return (
        <>
            {count > 0 && (
                withClear ? (
                    <Grid
                        templateColumns="auto 1fr"
                        gap="2rem"
                        {...props}
                    >
                        <Grid>
                            <Grid
                                onClick={() => handleOpen()}
                                cursor="pointer"
                            >
                                <Box margin="auto">
                                    <LuTrash
                                        color="#000000"
                                        size="1.5rem"
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Counter
                            margin="0 auto 0 0"
                            value={count}
                            onValueChange={(v) => (v === 0
                                ? setOpen(true)
                                : setItem(
                                    type,
                                    uid,
                                    v,
                                    portionIndex,
                                ))}
                        />
                    </Grid>
                ) : (
                    <Grid
                        templateColumns="auto 1fr"
                        {...props}
                    >
                        <Grid>
                            <Counter
                                margin="0 auto 0 0"
                                value={count}
                                onValueChange={(v) => (v === 0
                                    ? setOpen(true)
                                    : setItem(
                                        type,
                                        uid,
                                        v,
                                        portionIndex,
                                    ))}
                            />
                        </Grid>
                        <Grid
                            padding="1rem"
                            background="#E74C3C"
                            cursor="pointer"
                            onClick={() => navigate('/cart')}
                        >
                            <Grid
                                templateColumns="auto"
                                gap="0.5rem"
                                margin="auto"
                            >
                                {/* <Text
                                    fontSize="1rem"
                                    color="white"
                                    fontWeight="bold"
                                >
                                    В
                                </Text> */}
                                {/* <Box margin="auto">
                                    <Icon
                                        height="1rem"
                                        width="1rem"
                                        color="white"
                                        iconName={IconsNames.ArrowRight}
                                    />
                                </Box> */}
                                <Box margin="auto">
                                    <Icon
                                        height="1rem"
                                        width="1rem"
                                        iconName={IconsNames.Cart}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                )
            )}
            {count === 0 && (
                <Button
                    onClick={() => setItem(type, uid, 1)}
                    background="#000000"
                    padding="1rem"
                    cursor="pointer"
                    height="100%"
                >
                    <Grid templateColumns="auto 1fr" gap="1rem">
                        <Box margin="auto">
                            <Icon
                                height="1rem"
                                width="1rem"
                                color="white"
                                iconName={IconsNames.Plus}
                            />
                        </Box>
                        <Text fontWeight="bold" margin="auto 0">
                            добавить
                        </Text>
                    </Grid>
                </Button>
            )}
            <Modal
                title="Убрать из корзины?"
                open={open}
                onChange={(v) => setOpen(v)}
            >
                <Grid
                    position="relative"
                >
                    <Grid templateColumns="2fr 1fr" gap="1rem">
                        <Button
                            onClick={() => {
                                handleClose();
                            }}
                            background="#000000"
                        >
                            <Text
                                fontSize="1rem"
                                fontWeight={900}
                                color="white"
                            >
                                Отменить
                            </Text>
                        </Button>
                        <Button
                            onClick={() => {
                                setItem(type, uid, 0, portionIndex);
                                handleClose();
                            }}
                            background="#E74C3C"
                        >
                            <Text
                                fontSize="1rem"
                                fontWeight={900}
                                color="white"
                            >
                                Подтвердить
                            </Text>
                        </Button>
                    </Grid>
                </Grid>
            </Modal>
        </>
    );
};
